"use strict";

import Firebase from "firebase/app";

/**
 * timestamp (REST 経由)
 * {"_seconds":1657756553, "_nanoseconds":107000000}
 */
export const toTimestamp = (timestampJS) => {
  return new Firebase.firestore.Timestamp(timestampJS._seconds, timestampJS._nanoseconds);
}
